import ItemId from 'owa-service/lib/contract/ItemId';
import { ClientItem, mailStore } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setSmartPillClickStatus', (itemId: ItemId, isClicked: boolean) => {
    const item: ClientItem = mailStore.items.get(itemId.Id);
    if (item) {
        item.isSmartPillClicked = isClicked;
    }
});
